import { useCallback, useEffect, useState } from 'react'
import { MapWithCompetitors } from '../../../../../../../shared/widgets/MapWithCompetitors'
import { useMemo } from 'react'

interface MapWithCompetitorsContainerProps {
    hostServices?: any
    selectedHostService?: any
    count?: number
    spyId?: number
    loading?: boolean
    location?: any
    hostServicesFilteredByMapBounds?: any[]
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
    onSelectHostService: (event: any) => void
    onUnselectHostService: (event: any) => void
    onMapBoundsChanged?: (event: any) => void
}

export const MapWithCompetitorsContainer = (props: MapWithCompetitorsContainerProps): JSX.Element => {
    const {
        hostServices,
        selectedHostService,
        hostServicesFilteredByMapBounds,
        count,
        spyId,
        location,
        onStartPropertySpy,
        onStopPropertySpy,
        onSelectHostService,
        onUnselectHostService,
        onMapBoundsChanged,
        loading
    } = props


    const [selectedHostServices, setSelectedHostServices] = useState<any[]>([])

    const handleMarkerClick = useCallback((event: any) => {
        setSelectedHostServices([event])
        onSelectHostService(event)
    }, [])

    const handleCloseDetailWindow = (event: any) => {
        setSelectedHostServices([])
        onUnselectHostService?.(event)
    }
    const selectedHostServices1 = useMemo(() => {
        const foundHostservices = selectedHostServices.filter((selectedhostService: any) => {
            return hostServices?.some((hostService: any) => {
                return selectedhostService.id === hostService.id
            })
        })

        return foundHostservices
    }, [
        hostServices,
        selectedHostServices
    ])

    const performMapBoundsChanged = (event: any) => {
        onMapBoundsChanged?.(event)
    }

    const handleMapBoundsChanged = (event: any) => {
        performMapBoundsChanged(event)
    }

    return (
            <>
                <MapWithCompetitors
                    hostServices={hostServices}
                    count={count}
                    spyId={spyId}
                    location={location}
                    selectedHostService={selectedHostService}
                    selectedHostServices={selectedHostServices1}
                    hostServicesFilteredByMapBounds={hostServicesFilteredByMapBounds}
                    onMarkerClick={handleMarkerClick}
                    onStartPropertySpy={onStartPropertySpy}
                    onStopPropertySpy={onStopPropertySpy}
                    onCloseDetailWindow={handleCloseDetailWindow}
                    onMapBoundsChanged={handleMapBoundsChanged}
                    loading={loading}
                />
            </>
        )
}